































import { Component, Vue, Prop, Emit, PropSync } from "vue-property-decorator";

@Component
export default class SimpleMessageBox extends Vue {
  @PropSync("showDialog") syncedShowDialog!: boolean;
  @Prop({ required: true, type: String }) readonly title!: string;
  @Prop({ required: true, type: String }) readonly text!: string;
  @Prop({ type: Boolean, default: false }) readonly showCloseButton!: boolean;
  @Prop({ type: Boolean, default: true }) readonly showYesButton!: boolean;
  @Prop({ type: Boolean, default: true }) readonly showNoButton!: boolean;
  @Prop({ type: String, default: 'mdi-help' }) readonly icon!: string;

  @Emit("no:simpleMessageBox")
  onNo(): void {
    // Emits 'no' event when the "Nein" button is clicked
    this.syncedShowDialog = false;
  }

  @Emit("yes:simpleMessageBox")
  onYes(): void {
    // Emits 'yes' event when the "Ja" button is clicked
    this.syncedShowDialog = false;
  }

  onClose(): void {
    // Closes the dialog without emitting any event
    this.syncedShowDialog = false;
  }
}
